/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/14
 * Time: 11:26
 * Desc: 试穿及出样设置-出样设置
 */

import { Component, Vue } from 'vue-property-decorator';
import type { ElForm } from 'element-ui/types/form';
import { IPSService } from '@/services/ipsServices';

@Component
export default class ExampleSetting extends Vue {
  /* 数据 */

  /**
   * 出样设置表单
   * @type {ItemObject}
   */
  public exampleSettingForm: ItemObject = {
    bookingCount: 1,
    bookingInterval: 1,
    radius: 0,
    processIntro: '',
  };

  /**
   * 数据效验（整数）
   * @type {Function}
   */
  public numberRule = (rule, value, callback) => {
    const reg = /^\d*$/;
    if (value === '') {
      callback(new Error('不能为空'));
    } else if (!reg.test(value)) {
      callback(new Error('请输入不小于0的整数'));
    } else {
      callback();
    }
  };

  /**
   * 出样设置表单验证规则
   * @type {ItemObject}
   */
  public exampleSettingFormRules: ItemObject = {
    bookingCount: [{ validator: this.numberRule, trigger: 'blur' }],
    bookingInterval: [{ validator: this.numberRule, trigger: 'blur' }],
    radius: [{ validator: this.numberRule, trigger: 'blur' }],
  };

  /* 方法 */

  /**
   * 获取集团顾客试穿和导购出样配置信息
   * @return null
   */
  public getGroupConfig(): void {
    IPSService.getGroupConfig({}).then((res) => {
      this.exampleSettingForm.bookingCount = res.guiderTryOnPerNum;
      this.exampleSettingForm.bookingInterval = res.guiderTryOnIntervalMinutes;
      this.exampleSettingForm.radius = res.guiderTryOnDistance;
      this.exampleSettingForm.processIntro = res.guiderTryOnDesc;
    });
  }

  /**
   * 保存集团顾客试穿和导购出样相关配置信息
   * @return null
   */
  public onSaveGroupConfig(): void {
    (this.$refs.exampleSettingForm as ElForm).validate((val) => {
      if (val) {
        // 去除两端多余的空格
        this.exampleSettingForm.processIntro = this.exampleSettingForm.processIntro ? this.exampleSettingForm.processIntro.replace(/^\s+|\s+$/, '') : '';
        const postParams = {
          moduleType: 2, // 1：试穿设置，2：出样设置，3：其他设置
          guiderTryOnPerNum: this.exampleSettingForm.bookingCount,
          guiderTryOnIntervalMinutes: this.exampleSettingForm.bookingInterval,
          guiderTryOnDistance: this.exampleSettingForm.radius,
          guiderTryOnDesc: this.exampleSettingForm.processIntro,
        };
        IPSService.saveGroupConfig({ postParams }).then((res) => {
          if (res.ret) {
            this.$message.success('保存成功');
          } else {
            this.$message.error('保存失败');
          }
        });
      } else {
        return false;
      }
    });
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    this.getGroupConfig(); // 获取集团顾客试穿和导购出样配置信息
  }
}
